<template>
  <div class="Business">
    <div class="Business__Header">
      <Header :title="$t('dashboard.business')" />
    </div>
    <BusinessMetrics />
    <div class="Business__Content">
      <BusinessAmount />
      <BusinessMap />
    </div>
    <div class="Business__Select">
      <FilterDisplay
        :options="sectors"
        :placeholder="placeholder"
        :value="value"
        class="filter"
      />
    </div>
    <FilteredBusinessData />
  </div>
</template>

<script>
import { Header, FilterDisplay, FilteredBusinessData } from '@/components';
import { getDataToFilterBusiness } from '@/api';

import BusinessMetrics from './BusinessMetrics';
import BusinessAmount from './BusinessAmount';
import BusinessMap from './BusinessMap';

export default {
  name: 'Business',
  data() {
    return {
      sectors: [],
      placeholder:this.$t('business.placeholder-sector'),
      title: this.$t('business.filter-sector'),
      value: {},
    };
  },
  components: {
    FilterDisplay,
    Header,
    BusinessMetrics,
    BusinessMap,
    FilteredBusinessData,
    BusinessAmount,
  },
  created() {
    getDataToFilterBusiness().then(
      data => {
        this.sectors = data.map(item => item);
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>
<style lang="scss">
.Business {
  width: 100%;
  height: 100%;
  &__Header {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__Content {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: rem(20);
    margin-bottom: rem(20);
  }
  &__Select {
    width: 25%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .filter {
      width: 50%;
    }
  }
}
</style>
